import BreadCrumb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import BreadCrumbSegukids from 'components/BreadCrumbMex/BreadCrumbSegukids';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import React from 'react';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';

const BreadCrumbPago = ({ codProducto, newRoutes, isPagoRealizado }) => {
  return (
    <React.Fragment>
      <BreadCrumb {...PASOS_BREADCRUMBS?.[codProducto]?.breadCrumb} />

      {[
        PRODUCTOS.pymesAbiertoInd,
        PRODUCTOS.PRESUSCRITOS,
        PRODUCTOS.HOGAR,
        PRODUCTOS.LINEAS_FINANCIERAS,
        PRODUCTOS.RCP,
        PRODUCTOS.CYBER,
        PRODUCTOS.HOGAR_DTC,
        PRODUCTOS.DO,
        PRODUCTOS.CASUALITY,
        PRODUCTOS.CASUALITY_GENERAL,
      ].includes(codProducto) &&
        newRoutes?.suscripcion?.itemBreadCrumb && (
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS?.[codProducto]?.breadCrumbPasosEmision?.[newRoutes?.suscripcion?.itemBreadCrumb]}
            styleimg={codProducto === PRODUCTOS.LINEAS_FINANCIERAS ? 'height200px mr-3' : ''}
            pasos={PASOS_BREADCRUMBS?.[codProducto]?.pasosEmision}
          />
        )}

      {[PRODUCTOS.APINDIVIDUAL, PRODUCTOS.CASUALITY].includes(codProducto) && (
        <BreadCrumbPasosV2
          {...PASOS_BREADCRUMBS?.[codProducto]?.breadCrumbPasosCotizacion?.[5]}
          pasos={PASOS_BREADCRUMBS?.[codProducto]?.pasosCotizacion}
        />
      )}
      {[PRODUCTOS.CASUALITY_GENERAL].includes(codProducto) && (
        <BreadCrumbPasosV2
          {...PASOS_BREADCRUMBS?.[codProducto]?.breadCrumbPasosCotizacion?.[6]}
          pasos={PASOS_BREADCRUMBS?.[codProducto]?.pasosCotizacion}
        />
      )}
      {![
        PRODUCTOS.pymesAbiertoInd,
        PRODUCTOS.PRESUSCRITOS,
        PRODUCTOS.HOGAR_DTC,
        PRODUCTOS.HOGAR,
        PRODUCTOS.HOGAR_FLEX,
        PRODUCTOS.APINDIVIDUAL,
        PRODUCTOS.LINEAS_FINANCIERAS,
        PRODUCTOS.RCP,
        PRODUCTOS.CYBER,
        PRODUCTOS.MARINE_INLAND,
        PRODUCTOS.DO,
        PRODUCTOS.CASUALITY,
        PRODUCTOS.CASUALITY_GENERAL,
        PRODUCTOS.SEGUKIDS,
      ].includes(codProducto) && <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[4]} />}

      {PRODUCTOS.HOGAR_FLEX === codProducto && (
        <BreadCrumbPasosV2
          {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR_FLEX].breadCrumbPasosCotizacionHogarFlex[8]}
          pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR_FLEX].pasosHogarFlex}
        />
      )}
      {PRODUCTOS.MARINE_INLAND === codProducto && (
        <BreadCrumbPasosV2 {...PASOS_BREADCRUMBS[PRODUCTOS.MARINE_INLAND].breadCrumbPasos[isPagoRealizado ? 8 : 7]} />
      )}
      {PRODUCTOS.SEGUKIDS === codProducto && (
        <BreadCrumbSegukids
          {...PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS].breadCrumbPasosSegukids[7]}
          pasos={PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS]?.pasosContratante}
          showImg={false}
          showImgTitle={true}
          subtitleClassnames={'col-md-12 mx-0'}
          styleimg="p-5"
        />
      )}
    </React.Fragment>
  );
};

export default BreadCrumbPago;
